const DEV = process.env.NODE_ENV === 'development'

export default {
  init() {
    const editorialElement = document.getElementById('editorialAnimation')
    const editorialVideoElement = document.getElementById(
      'editorialVideoAnimation'
    )
    const editorialAnimationStatuaElement = document.getElementById(
      'editorialStatuaAnimation'
    )
    const coverIframePinned = document.getElementById('coverIframePinned')

    if (editorialElement) {
      import('../modules/coccodrillo.js')
        .then((module) => {
          module.initCoccodrilloAnimation()
        })
        .catch((error) => {
          console.error('Errore nel caricamento di editorialAnimation:', error)
        })
    }

    if (editorialVideoElement) {
      import('../modules/videoHeader.js')
        .then((module) => {
          module.initVideoAnimation()
        })
        .catch((error) => {
          console.error(
            'Errore nel caricamento di editorialVideoAnimation:',
            error
          )
        })
    }

    if (editorialAnimationStatuaElement) {
      import('../modules/statua.js')
        .then((module) => {
          module.initStatuaAnimation()
        })
        .catch((error) => {
          console.error(
            'Errore nel caricamento di editorialAnimationStatuaElement:',
            error
          )
        })
    }

    if (coverIframePinned) {
      import('../modules/coverIframePinned.js')
        .then((module) => {
          module.init()
        })
        .catch((error) => {
          console.error('Errore nel caricamento di coverIframePinned:', error)
        })
    }
  },

  finalize() {
    // cleanup se serve
  },
}
